import React, { Component, useEffect, useState } from 'react';
// import { Dialog, DialogContent, DialogTitle, IconButton } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import Responsive from '../../../utils/Responsive';
import cx from '../../../utils/cx';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import styles from './Modal.scss';
import ModalSteps from './ModalSteps';
import { IPropertyWizardInput } from '../NewPropertyWizard';

export interface IModalProps extends IPropertyWizardInput {
    moderationState?: string;
    onClose: () => void;
}

const Modal: React.FC<React.PropsWithChildren<IModalProps>> = ({ step, data, onChange, isLoading, moderationState, open, onClose }) => {
    const [isOpen, setIsOpen] = useState(open === true);

    useEffect(() => {
        setIsOpen(open === true);
    }, [open]);

    const fullScreen = Responsive.getWidth() < 360;

    const handleClose = (ev, x) => {
        setIsOpen(false);
        onClose();
    };

    const scroll = 'paper';

    return (
        <Dialog open={isOpen} onClose={handleClose} fullWidth maxWidth="sm" fullScreen={fullScreen} scroll={scroll} className={cx('App__app___dnz')}>
            <DialogTitle sx={{ m: 0, p: 2 }} className={styles.phoneNumberDialog}>
                Bist du es wirklich?
                {handleClose ? (
                    <IconButton
                        aria-label="Schließen"
                        onClick={(ev) => {
                            ev.persist();
                            handleClose(ev, null);
                        }}
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8,
                            color: (theme) => theme.palette.grey[500],
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                ) : null}
            </DialogTitle>
            <ModalSteps
                step={step}
                data={data}
                onChange={onChange}
                isLoading={isLoading}
                moderationState={moderationState}
            />
        </Dialog>
    );
};

export default Modal;
